import React, { createContext, useContext, useState, useEffect } from 'react'
import { translations } from './translations'

const LangContext = createContext(null)

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const stored = localStorage.getItem('eqpi_lang')
    if (stored === 'en' || stored === 'pt') return stored
    return (navigator.language || '').toLowerCase().startsWith('en') ? 'en' : 'pt'
  })

  useEffect(() => {
    document.documentElement.lang = lang === 'pt' ? 'pt-BR' : 'en'
  }, [lang])

  const setLanguage = (l) => {
    localStorage.setItem('eqpi_lang', l)
    setLangState(l)
  }

  const T = translations[lang]

  return (
    <LangContext.Provider value={{ lang, setLanguage, T }}>
      {children}
    </LangContext.Provider>
  )
}

export const useLang = () => useContext(LangContext)
